import ChevronRight from '@mui/icons-material/ChevronRight';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import Tooltip from '@zenbusiness/zui/Tooltip';

import { INFO_ICON_SX, INFO_TOOLTIP_SLOT_PROPS } from './OrderTracker.styles';
import * as Styled from './OrderTracker.styles';

function OrderTrackerItem({
  color,
  ctaMessageId,
  eventCallback,
  hoverTooltipMessageId,
  infoTooltipMessageId,
  infoTooltipTitleId,
  isClickable = true,
  justifyContent = 'space-between',
  onClick,
  showChevron = true,
  titleMessageId,
  titleMessageSuffix = '',
  type
}) {
  const handleOnClick = () => {
    if (!isClickable) return;

    if (eventCallback) {
      eventCallback();
    }

    if (onClick) {
      onClick();
    }
  };

  const ItemContainer = isClickable
    ? Styled.StyledOrderTrackerItem
    : Styled.StyledOrderTrackerItemStatic;
  const shouldShowChevron = isClickable && showChevron;
  const chipContent = (
    <Styled.StyledChip
      color={color}
    >
      <FormattedMessage id={ctaMessageId} />
    </Styled.StyledChip>
  );

  return (
    <ItemContainer
      data-testid={`order-tracker-item-${type}`}
      display="flex"
      justifyContent={justifyContent}
      width="100%"
      padding="1rem"
      onClick={isClickable ? handleOnClick : undefined}
    >
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Text weight="medium" paddingRight={infoTooltipMessageId ? '0' : '1rem'}>
          <FormattedMessage
            id={titleMessageId}
          />
          {titleMessageSuffix}
        </Text>
        {infoTooltipMessageId && (
          <Tooltip
            arrow={false}
            enterTouchDelay={0}
            leaveTouchDelay={15000}
            slotProps={INFO_TOOLTIP_SLOT_PROPS}
            title={(
              <Stack spacing={0.5}>
                {infoTooltipTitleId && (
                  <Text size="sm" sx={{ fontWeight: 600 }}>
                    <FormattedMessage id={infoTooltipTitleId} />
                  </Text>
                )}
                <Text size="xs" weight="regular">
                  <FormattedMessage id={infoTooltipMessageId} />
                </Text>
              </Stack>
            )}
            placement="bottom-start"
          >
            <InfoOutlined
              sx={INFO_ICON_SX}
              data-testid={`info-tooltip-${type}`}
              onClick={(e) => e.stopPropagation()}
            />
          </Tooltip>
        )}
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        {hoverTooltipMessageId ? (
          <Tooltip
            arrow={false}
            enterTouchDelay={0}
            leaveTouchDelay={15000}
            title={(
              <Text size="xs" weight="regular">
                <FormattedMessage id={hoverTooltipMessageId} />
              </Text>
            )}
            placement="top-start"
          >
            <Box display="inline-flex">
              {chipContent}
            </Box>
          </Tooltip>
        ) : chipContent}
        {shouldShowChevron && <ChevronRight />}
      </Stack>
    </ItemContainer>
  );
}

OrderTrackerItem.propTypes = {
  color: PropTypes.string.isRequired,
  ctaMessageId: PropTypes.string.isRequired,
  eventCallback: PropTypes.func,
  hoverTooltipMessageId: PropTypes.string,
  infoTooltipMessageId: PropTypes.string,
  infoTooltipTitleId: PropTypes.string,
  isClickable: PropTypes.bool,
  justifyContent: PropTypes.string,
  onClick: PropTypes.func,
  showChevron: PropTypes.bool,
  titleMessageId: PropTypes.string.isRequired,
  titleMessageSuffix: PropTypes.string,
  type: PropTypes.string.isRequired
};

export default OrderTrackerItem;
